import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=53ba221a&scoped=true&"
import script from "./BaseConfirm.vue?vue&type=script&lang=ts&"
export * from "./BaseConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./BaseConfirm.vue?vue&type=style&index=0&id=53ba221a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ba221a",
  null
  
)

export default component.exports